var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="col-11" data-mount="item-content"></div>\n\n';
 if (!readOnly) { 
__p+='\n<div class="col-1 col-form-label position-relative">\n    <a href="#" data-action="remove-item" class="position-absolute add-list__close">\n        <i data-icon="close"></i>\n    </a>\n</div>\n';
 } 
__p+='\n';
}
return __p;
};
